import React from "react";
import "./Footer.css";
import { Link, useNavigate } from "react-router-dom";

function Footer() {
  return (
    <footer className="footer-area">
      <div className="container">
        <div className="followus_box">
          <h4>Follow Us</h4>
          <div className="d-flex flex-wrap align-items-center justify-content-center gap-2">
            <a href="https://www.x.com/PizzaMaxIE">
              <i className="fa-brands fa-twitter"></i>
            </a>
            <a href="https://www.instagram.com/pizzamax.ireland/">
              <i className="fa-brands fa-instagram"></i>
            </a>
            <a href="https://www.facebook.com/PizzaMaxIreland/">
              <i className="fa-brands fa-square-facebook"></i>
            </a>
          </div>
        </div>
        <div className="footer-menu">
          <ul className="d-flex align-items-center gap-2 justify-content-center">
            <li>
              <Link to="/disclaimer">Disclaimer</Link>
            </li>
            <li>
              <Link to="/privacy-policy">Privacy Policy</Link>
            </li>
            <li>
              <Link to="/terms-and-conditions">Terms & Conditions</Link>
            </li>
            <li>
              <Link to="/nutritional-information">Nutritional Information</Link>
            </li>
          </ul>
        </div>
        <div className="appbox">
          <h4>Download App</h4>
          <div className="d-flex align-items-center justify-content-center gap-2">
            <a href="https://play.google.com/store/apps/details?id=com.easydish.apps.pizzamax">
              <img
                src={require("../../assets/icons/google-play.png")}
                alt="googleplay"
              />
            </a>
            <a href="https://apps.apple.com/us/app/pizza-max-ireland/id6445921346">
              <img
                src={require("../../assets/icons/app-store.png")}
                alt="appstore"
              />
            </a>
          </div>
        </div>
        <div className="copyright">© 2025 PizzaMax. All rights reserved.</div>
      </div>
    </footer>
  );
}

export default Footer;
